import { IServiceFactory } from '../../common/types/service-factory';
import { IViewsApiService, ViewsApiService } from '../services/view-api-service';
import { ApiServiceFactoryBase } from './base/api-service-factory-base';

export class ViewsApiServiceFactory extends ApiServiceFactoryBase implements IServiceFactory<IViewsApiService> {
	public Create(): IViewsApiService {
		return new ViewsApiService(this.apiServiceFactory.Create(), this.appConfigService);
	}
}
